let initHandler: (() => Promise<void> | void) | null = null
let initPromise: Promise<void> | null = null

export const registerAppInit = (handler: () => Promise<void> | void) => {
  initHandler = handler
}

export const runAppInit = async () => {
  if (!initHandler) {
    return
  }

  if (initPromise) {
    return initPromise
  }

  initPromise = Promise.resolve(initHandler()).finally(() => {
    initPromise = null
  })

  return initPromise
}
